export const FILTERED_DOMAINS = [
    'hotmail.com',
    'yahoo.com',
    'aol.com',
    'gmail.com',
    'outlook.com',
    'live.com',
    'me.com',
    'icloud.com',
    'msn.com',
    'infusionsoft.com',
    'google.com',
    'thryv.com',
];

export const DOMAIN_AUTH_RECORD_TYPES = {
    LEGACY: 'LEGACY',
    S1: 'S1',
    S2: 'S2',
    DMARC: 'DMARC',
    SPF: 'SPF',
};

export function filterDomains(domains) {
    return domains.filter(({ domain }) => {
        return FILTERED_DOMAINS.indexOf(domain) === -1;
    });
}

export function mapDomains(domains) {
    const domainsFiltered = filterDomains(domains);

    return domainsFiltered.reduce(
        (map, domain) => {
            if (map.has(domain.domain)) {
                const existing = map.get(domain.domain);

                const recordSet = {
                    records: {
                        ...existing.records,
                        [domain.emailAuthType]: domain,
                    },
                };

                return map.set(domain.domain, recordSet);
            }

            const recordSet = {
                records: {
                    [domain.emailAuthType]: domain,
                },
            };

            return map.set(domain.domain, recordSet);
        },
        new Map(),
    );
}

export function getVerifiedDomainsKeysOrDmarc(domains) {
    const domainsMapped = mapDomains(domains);
    const domainsVerified = [];

    domainsMapped.forEach((value, key) => {
        const { records } = value;

        const verifiedSpf = records.SPF && records.SPF.verified;
        const verifiedS1 = records.S1 && records.S1.verified;
        const verifiedS2 = records.S2 && records.S2.verified;
        const verifiedDmarc = records.DMARC && records.DMARC.verified;
        const verifiedLegacy = records.LEGACY && records.LEGACY.verified;
        const verifiedNew = verifiedSpf && verifiedS1 && verifiedS2 && verifiedDmarc;
        const verifedLegacyDmarc = verifiedLegacy && verifiedDmarc;

        if (verifedLegacyDmarc || verifiedNew) {
            domainsVerified.push(key);
        }
    });

    return domainsVerified;
}

export function getVerifiedDomainsNewKeys(domains) {
    const domainsMapped = mapDomains(domains);
    const domainsVerified = [];

    domainsMapped.forEach((value, key) => {
        const { records } = value;

        const verifiedSpf = records.SPF && records.SPF.verified;
        const verifiedS1 = records.S1 && records.S1.verified;
        const verifiedS2 = records.S2 && records.S2.verified;
        const verifiedDmarc = records.DMARC && records.DMARC.verified;
        const verified = verifiedSpf && verifiedS1 && verifiedS2 && verifiedDmarc;

        if (verified) {
            domainsVerified.push(key);
        }
    });

    return domainsVerified;
}
